import m from 'moment-timezone';

import deviceUses24Hour from '@/helpers/device-uses-24-hour';
import formatDate from '@/helpers/format/format-date';



function momentCalendar(value, customFormats, timeZone) {
  /**
   * https://momentjs.com/docs/#/customization/calendar/
   *
   * The time portion is chosen from the device's CLDR hour cycle rather than
   * moment's `LT` token. `LT` reads moment.locale(), which only knows about
   * the locales registered in `constants/supported-locales.js` — every other
   * locale falls back to en-US (12-hour). Going through `deviceUses24Hour()`
   * means de-DE, ja-JP, fr-FR, etc. all render in 24-hour even though they
   * are not formally supported elsewhere.
   *
   * The fallback (lastWeek/sameElse) date portion uses formatDate with the
   * device's raw navigator.language so en-GB/en-AU see "DD/MM/YYYY" while
   * en-US sees "M/D/YYYY". Wrapping in [...] escapes the formatted string
   * from moment's format-token parsing.
   */
  const timeFormat = deviceUses24Hour() ? 'HH:mm' : 'h:mm A';

  function localeAwareDateFormat() {
    const date = formatDate(this.toDate(), { timeZone });
    return `[${date}] [@] ${timeFormat}`;
  }

  const defaultFormats = {
    sameDay: `[Today @] ${timeFormat}`,
    nextDay: `[Tomorrow @] ${timeFormat}`,
    lastDay: `[Yesterday @] ${timeFormat}`,
    nextWeek: `dddd [@] ${timeFormat}`,
    lastWeek: localeAwareDateFormat,
    sameElse: localeAwareDateFormat
  };

  const formats = customFormats || defaultFormats;

  if (value && timeZone) {
    return m(value).tz(timeZone).calendar(null, formats);
  }

  if (value) {
    return m(value).calendar(null, formats);
  }

  return '';
}



export default momentCalendar;
